<template>
    <div>
        <el-form label-position="top" @submit.native.prevent>
            <el-row class="u-mt-10 u-mb-20" :gutter="10">
                <el-col :xs="24" :sm="8" :md="6">
                    <el-form-item label="Período diagnóstico">
                        <el-select v-model="filtro.periodo_id" placeholder="Selecione" @change="load" clearable style="width: 100%;">
                            <el-option v-for="p in periodos" :key="p.id" :label="p.descricao" :value="p.id"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="8" :md="6" v-if="precisaSelecionarEscola">
                    <el-form-item label="Escola">
                        <el-select v-model="filtro.instituicao_id" placeholder="Selecione" @change="load" filterable style="width: 100%;">
                            <el-option v-for="e in instituicoes" :key="e.id" :label="e.nome" :value="e.id"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>

        <div v-if="!filtro.periodo_id || (precisaSelecionarEscola && !filtro.instituicao_id)" class="u-text-center u-mt-25" style="color: #909399;">
            Selecione {{ precisaSelecionarEscola ? 'a escola e ' : '' }}o período diagnóstico para visualizar as turmas.
        </div>

        <div v-else>
            <div v-if="!statusList" class="u-text-center u-mt-25">
                <img src="/public/img/loading-bar.gif" />
            </div>

            <div v-else>
                <div class="container-table" v-if="items.length">
                    <table class="table table-striped">
                        <thead>
                            <tr>
                                <th>Curso/Ano</th>
                                <th>Turma</th>
                                <th style="width: 90px;">Matric.</th>
                                <th style="width: 80px;">Lanç.</th>
                                <th style="width: 130px;">Status</th>
                                <th style="width: 160px;" class="u-text-center">Ação</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="item in items" :key="item.turma_id"
                                :style="item.inconsistente ? 'background:#fff5f5;' : ''">
                                <td>{{ item.curso_nome || '—' }}</td>
                                <td>{{ item.turma_nome }}</td>
                                <td>{{ item.matriculados }}</td>
                                <td>{{ item.lancados }}</td>
                                <td>
                                    <span v-if="item.status === 0" style="color: #909399;">Não iniciada</span>
                                    <span v-else-if="item.status === 1" style="color: #e6a23c;">Rascunho</span>
                                    <span v-else-if="item.status === 2" style="color: #67c23a;">Concluído</span>
                                    <span v-else-if="item.status === 3" style="color: #409eff;">Enviado à supervisão</span>
                                </td>
                                <td class="u-text-center acao">
                                    <router-link :to="urlLancamento(item)">
                                        <el-button type="primary" size="mini" plain>
                                            <i class="el-icon-edit"></i> {{ item.tabulacao_id ? 'Editar' : 'Iniciar' }}
                                        </el-button>
                                    </router-link>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div v-else class="u-text-center u-mt-25" style="color: #909399;">
                    Nenhuma turma cadastrada para esta escola no período letivo atual.
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        tipo: { type: String, required: true } // 'BASE' | 'DESENHO'
    },
    data: () => ({
        statusList: true,
        periodos: [],
        instituicoes: [],
        filtro: { periodo_id: '', instituicao_id: '' },
        items: []
    }),
    computed: {
        rotaBase () {
            return this.tipo === 'DESENHO' ? '/admin/tabulacao/coordenador/desenho' : '/admin/tabulacao/coordenador/base'
        },
        precisaSelecionarEscola () {
            // SMED/Consulta (4,5,6,7,8,10) não tem vínculo direto com uma instituição — precisa escolher.
            // Também precisa escolher se, por qualquer motivo, não houver instituição válida no store.
            const t = parseInt(this.$store.state.user.tipo)
            if ([4, 5, 6, 7, 8, 10].indexOf(t) >= 0) return true
            const inst = this.$store.state.config.instituicao
            return !inst || !inst.id
        }
    },
    mounted () {
        this.carregarPeriodos()
        if (!this.precisaSelecionarEscola) {
            const inst = this.$store.state.config.instituicao
            if (inst && inst.id) this.filtro.instituicao_id = inst.id
        } else {
            this.carregarInstituicoes()
        }
    },
    methods: {
        carregarPeriodos () {
            this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/periodo-diagnostico/getAll`, this.$store.getters.getHeaderAuth)
                .then(r => {
                    this.periodos = (r.data || []).filter(p => p.status === 1)
                    if (this.periodos.length === 1) {
                        this.filtro.periodo_id = this.periodos[0].id
                        this.load()
                    }
                })
        },
        carregarInstituicoes () {
            this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/instituicao/getAll`, this.$store.getters.getHeaderAuth)
                .then(r => { this.instituicoes = r.data || [] })
                .catch(() => { this.instituicoes = [] })
        },
        load () {
            if (!this.filtro.periodo_id || !this.filtro.instituicao_id) return
            this.statusList = false
            this.items = []
            const url = `${this.$store.state.config.baseUrlApi}/api/tabulacao/listaTurmas/${this.filtro.instituicao_id}/${this.filtro.periodo_id}/${this.tipo}`
            this.$axios.get(url, this.$store.getters.getHeaderAuth)
                .then(r => {
                    if (r.data && r.data.erro) {
                        window.eventBus.$emit('alert', { msg: typeof r.data.erro === 'string' ? r.data.erro : r.data.erro.text, type: 'warning' })
                    } else {
                        this.items = r.data || []
                    }
                    this.statusList = true
                })
                .catch(error => { this.statusList = true; this.$store.commit('throwException', error) })
        },
        urlLancamento (item) {
            return `${this.rotaBase}/turma/${item.turma_id}/periodo/${this.filtro.periodo_id}`
        }
    }
}
</script>
